export const lang = {
    lang: 'EN',
    home: '首页',
    laureates: '获奖人',
    nomination: '奖项与提名',
    donors: '捐赠人',
    detialDondor: '捐赠人',
    detialLaureates: '获奖人',
    news: '资讯',
    events: '大奖活动',
    awardabout: '关于大奖',

    future: '未来论坛',
    year: '年份',
    awards: '按奖项',
    winners: '按姓氏首字母',
    Notice: '公告',
    //未来大奖周导航
    agenda: '议程',
    academic: '学术指导',
    gegistration: '参会报名',
    partners: '合作伙伴',
    live: '直播',
    legacy: '往期回顾',
    volunteer: '志愿者招募',
    contact: '联系我们',
    //论坛导航
    home: '首页',
    Home: '首页',
    about: '关于我们',
    About: '关于我们',
    futureSience: '未来科学大奖',
    whatWeDo: '重要活动',
    futrueNews: '未来资讯',
    contactUs: '联系我们',
    _2020FSPL: '2020 未来科学大奖获奖者',
    nar_search: '请输入搜索内容',
    //首页导航
    aboutFSP: '未来科学大奖概述',
    Bylaw: '章程',
    Sciencecommittee: '科学委员会',
    Supervisorycommittee: '监督委员会',
    Contactus: '联系我们',
    WINNERS: '按姓氏首字母',
    YEAR: '按年份',
    Year: "年份",
    years: '年份',
    AWARDS: '按奖项',
    menuPrize: '奖项',
    Lifescienceprize: '生命科学奖',
    Physicalscienceprize: '物质科学奖',
    MCprize: '数学与计算机科学奖',
    mununotice: '公告',
    PressConference: '新闻发布会',
    IwithL: '获奖人专访',
    NandI: '更多',
    nar_search: '请输入搜索内容',
    VandM: '愿景使命',
    fminiAboutUs: '简介',
    fmsciencec: '科学委员会',
    Awardceremony: '颁奖典礼',
    Laureateslecture: '获奖人学术报告会',
    Symposium: '科学峰会',
    Inspirationinitiative: '青少年对话获奖人',
    Selectionrules: '评选规则',
    AllLaureates: '点击查看历届获奖人',
    Donor: '捐赠人：',
    Reward: '奖金：',
    LatestNews: '最新资讯',
    RelatedVideo: '相关视频',
    laureate: '获奖人',
    CFSPDC: '捐赠人大会轮值主席',
    Prizedonor: '捐赠人',
    FSPSymposium: "未来科学大奖科学峰会",
    FLSeries: '理解未来科学讲座',
    FutureRoundtable: '闭门耕',
    FutureReception: '未来·局',
    CitySummit: '病毒与人类健康-专题科普',
    RotatingChair: '轮值主席',
    SubcommitteeChair: '奖项委员会主席',
    Members: '委员',
    FormerMembers: '往届委员',
    Council: '理事会',
    MembersList: '成员',
    ExecutiveCommittee: '执行委员会',
    InstitutionalCouncil: '机构理事',
    YouthCouncil: '青年理事会',
    YOSIA: '青创联盟',
    FSPW2020: '2020 未来科学大奖周',
    FSPW2019: '2019 未来科学大奖周',
    FSPW2021: '2021 未来科学大奖周',
    AwardCeremony: '颁奖典礼',
    index2020: '2020 未来科学大奖获奖者',
    Responsibility: '职能',
    oversighttho: '监督管理资金运作',
    Oversighttsp: '监督评选流程',
    Ensuretapc: '确保公正、公平、公信',
    viuuesHuman: '病毒与人类健康专题科普',
    cityMeeting: '城市峰会',
    futureNew: ' 未来新闻',
    mediaNew: '媒体报道',
    AIscience: 'AI+科学系列',
    cooparationSupport: '合作支持',
    mediaSupport: '媒体支持',
    amedemicConcil: '学术合作机构',
    VoluteerSign: '志愿者报名',
    traineeSign: '实习生报名',
    Enroll: '报名',
    FulltimeJob: '全职工作',
    attention: "注意事项",
    partner: '战略伙伴',
    HandtInformation: "酒店和交通信息 ",
    Nominatedtime: "提名时间",
    STRATEGICPARTNERS: "战略合作",
    Hotelandtransportationinformation: "酒店和交通信息",
    YOSIAWebinar: 'YOSIA Webinar',
    time: '时间',
    groupPart: '组委会',
    RelatedReading: '相关阅读',
    Speeches: '演讲稿',
    LecturerProfiles: '讲者简介',
    inputPe: '科学改变未来',
    Summary: '摘要',
    UploadResume: '上传简历',
    submit: '提交',


}